export default __webpack_public_path__ + "static/KeywordResearch_01_02-0999887526f3c15c8fa3c1f7c172cf48.png";